module.exports = __webpack_public_path__ + "static/media/Group 119.6aac0891.png";